import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    questionState: [],
    GPTChat: [],
    chatTransactionId: '',
    isNormalFlow: true,
    initialUserChat: false
};

export const chatBotSlice = createSlice({
    name: 'chatBotData',
    initialState,
    reducers: {
        resetChatsState: () => initialState,
        updateQuestionState: (state, action) => {
            state.questionState = action.payload;
        },
        setGPTChats: (state, action) => {
            state.GPTChat = action.payload;
        },
        setChatTransactionId: (state, action) => {
            state.chatTransactionId = action.payload;
        },
        setIsNormalFlow: (state, action) => {
            state.isNormalFlow = action.payload;
        },
        setIsInitialUserChat: (state, action) => {
            state.initialUserChat = action.payload;
        },
        resetChatsInStore: (state) => {
            state.questionState = [];
            state.GPTChat = [];
            state.chatTransactionId = '';
            state.isNormalFlow = true;
        },
    },
});

export const getChatBotData = (state) => state.chatBotData;

// Action creators are generated for each case reducer function
export const {
    resetChatsState,
    updateQuestionState,
    setGPTChats,
    setChatTransactionId,
    setIsNormalFlow,
    setIsInitialUserChat,
    resetChatsInStore
} = chatBotSlice.actions;

export default chatBotSlice.reducer;
